import { gql } from '@apollo/client';

export const RELEASE_DISCOUNT_MUTATION = gql`
  mutation ReleaseDiscount($id: Int!) {
    p {
      releaseDiscount(id: $id) {
        success
        message {
          code
          message
        }
        content {
          id
          status
        }
      }
    }
  }
`;
